import React from 'react';
import { Box, Typography } from '@mui/material';

interface PackagerCronSuggestionsProps {
  onSelectExpression: (expression: string) => void;
}

const PackagerCronSuggestions: React.FC<PackagerCronSuggestionsProps> = ({
  onSelectExpression,
}) => {
  const cronExamples = [
    { expr: '0 17 * * *', desc: 'Daily at 5 PM' },
    { expr: '0 17 * * 5', desc: 'Weekly on Friday at 5 PM' },
    { expr: '0 17 1 * *', desc: 'Monthly on the 1st at 5 PM' },
    { expr: '0 8 * * 1-5', desc: 'Monday through Friday at 8 AM' },
  ];

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        backgroundColor: '#fafafa',
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 'bold' }}
      >
        Common examples (UTC):
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {cronExamples.map(({ expr, desc }) => (
          <Box
            key={expr}
            sx={{
              px: 1,
              py: 0.5,
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              cursor: 'pointer',
              fontSize: '0.75rem',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
            onClick={() => onSelectExpression(expr)}
          >
            <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
              {expr}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {desc}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PackagerCronSuggestions;
